// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"stars-view_shadow__1ep8E","starsWrapper":"stars-view_starsWrapper__Q4q-m","star":"stars-view_star__1bkOF"};